import { gql } from '@apollo/client'
import { eventResultFragment } from '~/graphql/fragments/eventResult'

export const GET_TRENDING_EVENTS = gql`
  query getTrendingEvents($countryCode: CountryCode) {
    nearby(countryCode: $countryCode) {
      trendingEvents(first: 5) {
        ...eventResult
      }
    }
  }
  ${eventResultFragment}
`
